'use client';

import type { PaymentMethod } from '@/features/payments/domain/model/payment-method';
import { TotemCheckoutSummary } from '@/features/totems/presentation/components/web-totem/checkout/totem-checkout-summary';
import { TotemPaymentMethodPicker } from '@/features/totems/presentation/components/web-totem/checkout/totem-payment-method-picker';

type Props = {
  methods: PaymentMethod[];
  cartTotal: number;
  amountTendered: string;
  onAmountTenderedChange: (amount: string) => void;
  onSelect: (method: PaymentMethod) => void;
  isPending: boolean;
  isWebTotem: boolean;
  isDashboard: boolean;
};

/** Paso inicial: elegir medio de pago, con la calculadora de vuelto y el resumen del carrito. */
export function CheckoutMethodStep({
  methods,
  cartTotal,
  amountTendered,
  onAmountTenderedChange,
  onSelect,
  isPending,
  isWebTotem,
  isDashboard,
}: Props) {
  return (
    <div className="grid min-h-0 flex-1 grid-cols-1 divide-y overflow-hidden bg-muted/10 md:grid-cols-12 md:divide-x md:divide-y-0">
      <div className="col-span-1 flex flex-col gap-8 overflow-y-auto p-6 md:col-span-7 md:p-8 lg:col-span-8 lg:p-10">
        <div className="flex-1 rounded-2xl border bg-background p-6 shadow-sm md:p-8">
          <TotemPaymentMethodPicker
            isPending={isPending}
            methods={methods}
            onSelect={onSelect}
            cartTotal={cartTotal}
            amountTendered={amountTendered}
            onAmountTenderedChange={onAmountTenderedChange}
            isWebTotem={isWebTotem}
            isDashboard={isDashboard}
          />
        </div>
      </div>

      <div className="col-span-1 flex min-h-0 flex-col bg-background p-6 md:col-span-5 md:p-8 lg:col-span-4">
        <div className="mb-6 flex min-h-0 flex-1 flex-col">
          <TotemCheckoutSummary />
        </div>
      </div>
    </div>
  );
}
